import script from "./MatterFeeRecipientsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatterFeeRecipientsTab.vue?vue&type=script&setup=true&lang=ts"

import "./MatterFeeRecipientsTab.vue?vue&type=style&index=0&id=6c57a219&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c57a219"]])

export default __exports__